module.exports = __webpack_public_path__ + "img/day_icon.3d9fba0e.svg";